import { useContext } from 'react';
import { PathContext } from './path-context';

export const usePathContext = () => {
  const context = useContext(PathContext);
  if (!context) {
    throw new Error('usePathContext must be used within a PathProvider');
  }
  return context;
};
